// extracted by mini-css-extract-plugin
export default {"products":"Zt-z","card":"_t-z","oosMessaging":"au-z"};